// extracted by mini-css-extract-plugin
export default {"TabNav":"CodeDropdownButton-module__TabNav--qDYNs","NavItem":"CodeDropdownButton-module__NavItem--UJ0Gr"};